import React from 'react'
import { FormattedMessage } from 'react-intl'
import diets from 'js/components/WhatIsLifesum/images/usp-diets.svg'
import mealPlans from 'js/components/WhatIsLifesum/images/usp-mealplans.svg'
import barCode from 'js/components/WhatIsLifesum/images/usp-barcode.svg'
import personalize from 'js/components/WhatIsLifesum/images/usp-personalize.svg'
import recipes from 'js/components/WhatIsLifesum/images/usp-recipes.svg'
import trackers from 'js/components/WhatIsLifesum/images/usp-trackers.svg'

const features = [
  {
    heading: (
      <FormattedMessage
        id="Features_Diets_Heading"
        defaultMessage="Diets you’ll love"
      />
    ),
    body: (
      <FormattedMessage
        id="Features_Diets_Body"
        defaultMessage="Nutritious Diets that fit your lifestyle and food preferences including High Protein and Clean Eating."
      />
    ),
    image: diets,
  },
  {
    heading: (
      <FormattedMessage
        id="Features_MealPlan_Heading"
        defaultMessage="Simplified Meal Plans"
      />
    ),
    body: (
      <FormattedMessage
        id="Features_MealPlan_Body"
        defaultMessage="1-3 week Meal Plans including Keto Burn and Vegan for a week. Four pre-planned recipes each day."
      />
    ),
    image: mealPlans,
  },
  {
    heading: (
      <FormattedMessage
        id="Features_Recipes_Heading"
        defaultMessage="Hundreds of recipes"
      />
    ),
    body: (
      <FormattedMessage
        id="Features_Recipes_Body"
        defaultMessage="Enjoy hundreds of easy-to-cook recipes filled with nutritious and tasty food."
      />
    ),
    image: recipes,
  },
  {
    heading: (
      <FormattedMessage
        id="Features_BarCode_Heading"
        defaultMessage="Helpful barcode scanner"
      />
    ),
    body: (
      <FormattedMessage
        id="Features_BarCode_Body"
        defaultMessage="Identify and scan your food items to get the nutritional information you need to stay on track."
      />
    ),
    image: barCode,
  },
  {
    heading: (
      <FormattedMessage
        id="Features_Trackers_Heading"
        defaultMessage="Track for success"
      />
    ),
    body: (
      <FormattedMessage
        id="Features_Trackers_Body"
        defaultMessage="Track your activities and what you eat with food-, exercise- and water trackers."
      />
    ),
    image: trackers,
  },
  {
    heading: (
      <FormattedMessage
        id="Features_Personalize_Heading"
        defaultMessage="Personalized health"
      />
    ),
    body: (
      <FormattedMessage
        id="Features_Personalize_Body"
        defaultMessage="Customize your health journey by adding your favorite food, recipes and exercise to your Favorites."
      />
    ),
    image: personalize,
  },
]

export default function Features() {
  return (
    <>
      <p className="type-med-plus mx-auto max-w-768 text-center">
        <FormattedMessage
          id="redeem_page_usp_title"
          defaultMessage="What you get"
        />
      </p>
      <div className="my-40 grid-cols-2 gap-6 md:my-64 md:grid lg:grid-cols-3 lg:gap-12">
        {features.map(({ heading, body, image }, i) => (
          <div
            key={i}
            className="leading-tight mb-20 w-full text-center md:mb-0"
          >
            <img
              src={image}
              alt=""
              className="mb-12 xl:mb-20"
              style={{ width: 'min(150px, 25vw)' }}
            />
            <h3 className="type-med-minus-fat lg:mb-4 xl:mb-8">{heading}</h3>
            <p className="leading-body">{body}</p>
          </div>
        ))}
      </div>
    </>
  )
}
